/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Response_TimeInputs */

const en_field_response_time = /** @type {(inputs: Field_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead Time`)
};

const es_field_response_time = /** @type {(inputs: Field_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plazo de entrega`)
};

const fr_field_response_time = /** @type {(inputs: Field_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Délai`)
};

const de_field_response_time = /** @type {(inputs: Field_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlaufzeit`)
};

const ja_field_response_time = /** @type {(inputs: Field_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リードタイム/納期`)
};

const zh_field_response_time = /** @type {(inputs: Field_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`备货时间`)
};

const ar_field_response_time = /** @type {(inputs: Field_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وقت الإنجاز`)
};

const id_field_response_time = /** @type {(inputs: Field_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu Tunggu`)
};

const it_field_response_time = /** @type {(inputs: Field_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo di Risposta`)
};

const ru_field_response_time = /** @type {(inputs: Field_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время отклика/Изготовления`)
};

const pt_field_response_time = /** @type {(inputs: Field_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prazo de Resposta`)
};

const ko_field_response_time = /** @type {(inputs: Field_Response_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소요 시간(리드 타임)`)
};

/**
* | output |
* | --- |
* | "Lead Time" |
*
* @param {Field_Response_TimeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_response_time = /** @type {((inputs?: Field_Response_TimeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Response_TimeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_response_time(inputs)
	if (locale === "es") return es_field_response_time(inputs)
	if (locale === "fr") return fr_field_response_time(inputs)
	if (locale === "de") return de_field_response_time(inputs)
	if (locale === "ja") return ja_field_response_time(inputs)
	if (locale === "zh") return zh_field_response_time(inputs)
	if (locale === "ar") return ar_field_response_time(inputs)
	if (locale === "id") return id_field_response_time(inputs)
	if (locale === "it") return it_field_response_time(inputs)
	if (locale === "ru") return ru_field_response_time(inputs)
	if (locale === "pt") return pt_field_response_time(inputs)
	return ko_field_response_time(inputs)
});